var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isReady)?_c(_vm.layout,{tag:"component",staticClass:"h-screen overflow-hidden font-inter"},[_c('router-view',{attrs:{"layout":_vm.layout},on:{"update:layout":function($event){_vm.layout=$event}}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }